export default function HowToBuy() {
  return (
    <section className="tw-py-20 tw-text-center tw-bg-white">
      <div className="tw-max-w-4xl tw-mx-auto tw-px-6">
        <h2 
          className="tw-text-4xl md:tw-text-5xl tw-font-medium tw-mb-8 tw-text-black"
          style={{ fontFamily: "'Instrument Serif', serif" }}
        >
          How to buy the Nestroots Protection Plan?
        </h2>

        <p 
          className="tw-text-xl md:tw-text-[22px] tw-text-gray-700 tw-leading-relaxed"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          You can add Nestroots Care to your cart when you buy Nestroots products on
          {" "}<a
            href="https://www.nestroots.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-text-black tw-font-semibold tw-underline tw-underline-offset-4 hover:tw-text-[#916B52] tw-transition-colors"
          >
            nestroots.com
          </a>.
          Product owners who are eligible for a Nestroots Protection Plan can find an offer
          directly on the Nestroots website.
        </p>
      </div>
    </section>
  );
}
